import { Observable, Subject } from 'rxjs';

import MqttConnection, { MqttConnectionStatus } from './mqtt-connetion';

interface subscription {
    id: string;
    callback: (message: string, data: any) => void;
}
export class MqttBroker {
    private static instance: MqttBroker | null = null;
    private mqttConnection = MqttConnection.getInstance();
    private subscribers: Map<string, subscription[]> = new Map<string, subscription[]>();
    private _connectionStatus: MqttConnectionStatus = MqttConnectionStatus.UNKNOWN;
    private _connectionStatusSubject = new Subject<MqttConnectionStatus>();

    public get connectionStatus(): MqttConnectionStatus {
        return this._connectionStatus;
    }
    public get connectionStatus$(): Observable<MqttConnectionStatus> {
        return this._connectionStatusSubject.asObservable();
    }
    private constructor() {
        this.mqttConnection.message$.subscribe((message) => {
            this.subscribers.forEach((subscribers, topic) => {
                if (topic === message.topic) {
                    subscribers.forEach((subscriber) => {
                        subscriber.callback(message.payload.message, message.payload.data);
                    });
                }
            });
        });

        this.mqttConnection.status$.subscribe((status) => {
            this._connectionStatus = status;
            this._connectionStatusSubject.next(status);
        });
    }

    public static getInstance(): MqttBroker {
        if (!MqttBroker.instance) {
            MqttBroker.instance = new MqttBroker();
        }
        return MqttBroker.instance;
    }

    subscribe(id: string, topic: string, callback: (value: string, data: any) => void): MqttBroker {
        const env = process.env['NX_PUBLIC_BUILD_ENV'];
        topic = env + '/' + topic;
        if (this.subscribers.has(topic)) {
            const topicSubscribers = this.subscribers.get(topic)!;
            const foundSubscription = topicSubscribers.find((s) => s.id === id);

            if (foundSubscription) {
                foundSubscription.callback = callback;
                return this;
            } else {
                topicSubscribers.push({ id, callback });
                return this;
            }
        } else {
            this.subscribers.set(topic, [{ id, callback }]);
            if (this.mqttConnection.topics.includes(topic)) return this;
            else this.mqttConnection.subscribe(topic);
        }
        return this;
    }

    unSubscribe(id: string, topic: string): MqttBroker {
        const env = process.env['NX_PUBLIC_BUILD_ENV'];
        topic = env + '/' + topic;
        if (!this.subscribers.has(topic)) return this;
        const topicSubscribers = this.subscribers.get(topic)!;
        const index = topicSubscribers.findIndex((s) => s.id === id);
        if (index === -1) return this;
        topicSubscribers.splice(index, 1);
        if (topicSubscribers.length === 0) {
            this.subscribers.delete(topic);
            setTimeout(() => {
                if (!this.subscribers.has(topic)) {
                    this.mqttConnection.unsubscribe(topic);
                }
            }, 2000);
        }
        return this;
    }

    disconnect(): void {
        this.mqttConnection.disconnect();
    }
}

export default MqttBroker;

export interface PubSubMessage {
    account_id: string;
    iot_id: string;
    workflow_id: string;
    id?: string;
    data: unknown;
    type: string;
    ids: unknown;
}
